import React from "react";

const loading = () => {
  return (
    <div className="lds-roller  mx-auto">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default loading;
